import { MetaTags } from "./meta-helper";

type RouteLike = string | { path?: string; fullPath?: string };
type Replacement = { k: string; v: string };
type PredefinedTags = { title: string; meta: Array<Record<string, any>> };
type MetaPageKey = keyof ReturnType<typeof MetaTags>;

function getPath(routeOrPath: RouteLike): string {
  if (typeof routeOrPath === "string") return routeOrPath;
  return routeOrPath.path || routeOrPath.fullPath || "";
}

export const generateMetaTags = (
  routeOrPath: RouteLike,
  page: MetaPageKey,
  replacements: Replacement[] = [],
): PredefinedTags => {
  const tags = JSON.parse(JSON.stringify(MetaTags()[page])) as PredefinedTags;
  const path = getPath(routeOrPath);

  tags.meta = generateOpenGraphFromMeta(tags, replacements, path);
  tags.title = replacePlaceHolderIfNecessary(tags.title, replacements);

  return tags;
};

export const generateOpenGraphFromMeta = (
  predefinedTags: PredefinedTags,
  replacements: Replacement[],
  path: string,
) => {
  // filter out invalid og tags
  predefinedTags.meta.forEach(
    (t) => (t.content = replacePlaceHolderIfNecessary(t.content, replacements)),
  );

  const ogTagAccumulator = [
    {
      hid: "og:url",
      property: "og:url",
      content: `https://www.esyoil.com${path}`,
    },
  ];

  const hasImageReplacement =
    replacements.filter((e) => e.k === "image").length > 0;

  if (!hasImageReplacement) {
    ogTagAccumulator.push({
      hid: "og:image",
      property: "og:image",
      content: `${process.env.PARTNER_MEDIA_CDN}/img/esyoil/esyoil-social-image.png`,
    });
  }

  const missingOgTags = predefinedTags.meta.filter((e) => {
    const searchTags = ["title", "description"];
    hasImageReplacement && searchTags.push("image");

    return searchTags.includes(e.name);
  });

  missingOgTags.forEach((tag) =>
    ogTagAccumulator.push({
      hid: `og:${tag.hid}`,
      property: `og:${tag.name}`,
      content: `${tag.content}`,
    }),
  );

  return [...ogTagAccumulator, ...predefinedTags.meta];
};

/**
 *
 * this function replaces ###key### value stuff in the meta strings.
 *
 * @param data key-value array of replacements ({ k: 'zipcode', v: '21339' })
 */
export const replacePlaceHolderIfNecessary = (input: string, data: Replacement[]) => {
  (data || []).forEach((r: Replacement) => {
    const regex = new RegExp(`###${r.k}###`, "g");
    input = input.replace(regex, r.v);
  });

  return input;
};

export const tabExitHandler = (instance) => {
  let timer = null;
  window.onpagehide = async (e) => {
    if ({ focus: 1, pageshow: 1 }[e.type]) {
      // window.clearInterval(timer);
      window.clearTimeout(timer);
      document.title = instance.$root.$meta().refresh().metaInfo.titleChunk;
    } else {
      timer = setTimeout(() => {
        // TODO: possible memory leak
        document.title = "⭐ Bis gleich! 👍";
      }, 2500);
    }
  };
};
